import { render, staticRenderFns } from "./downLoadCenterList.vue?vue&type=template&id=2a374f3a&scoped=true"
import script from "./downLoadCenterList.vue?vue&type=script&lang=js"
export * from "./downLoadCenterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a374f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a374f3a')) {
      api.createRecord('2a374f3a', component.options)
    } else {
      api.reload('2a374f3a', component.options)
    }
    module.hot.accept("./downLoadCenterList.vue?vue&type=template&id=2a374f3a&scoped=true", function () {
      api.rerender('2a374f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downLoadCenter/downLoadCenterList.vue"
export default component.exports